<template>
  <div class="yimiaoDiaocha">
    <div class="head">
      <div class="ques">你是否接种过新冠疫苗?</div>
      <div>
        <van-radio-group v-model="radio" direction="horizontal" class="sel">
          <van-radio name="1">
            <span> 是</span>
            <template #icon="props">
              <img
                class="img-icon"
                :src="props.checked ? activeIcon : inactiveIcon"
              />
            </template>
          </van-radio>
          <van-radio name="2">
            否
            <template #icon="props">
              <img
                class="img-icon"
                :src="props.checked ? activeIcon : inactiveIcon"
              />
            </template>
          </van-radio>
        </van-radio-group>
      </div>
    </div>
    <div class="form">
      <div class="everyForm">
        <div class="left">姓名</div>
        <div class="right">
          <input
            type="text"
            placeholder="请输入真实姓名"
            maxlength="16"
            v-model="name"
          />
        </div>
      </div>
      <div class="everyForm">
        <div class="left">证件类型</div>
        <div class="rightSel" @click="showSel">
          <div class="word" v-show="!typeShow">请选择</div>
          <div class="word2" v-show="typeShow">{{ type }}</div>
          <img src="../assets/images/yimiaoYoujian.png" alt="" />
        </div>
      </div>
      <div class="everyForm">
        <div class="left">证件号码</div>
        <div class="right">
          <input type="text" placeholder="请输入证件号码" v-model="cardNum" />
        </div>
      </div>
      <div class="everyForm last">
        <div class="left">手机号码</div>
        <div class="right">
          <input
            type="text"
            placeholder="请输入手机号码"
            maxlength="11"
            v-model="phone"
          />
        </div>
      </div>
    </div>
    <div class="dibu">
      <button @click="submit">立即提交</button>
    </div>
    <van-popup v-model="peiheShow" class="peihe">
      <div class="inpeihe">
        <div class="chaIcon" @click="peiheShow = false">
          <img src="../assets/images/yimiaoCha.png" alt="" />
        </div>
        <div class="title">尊敬的用户:</div>
        <div class="word1">
          当前新冠疫情仍然在全球流行，为进一步构建全民免疫屏障，请全体市民积极接种疫苗，让更多人群获得免疫力。
        </div>
        <div class="word1">
          为了巩固来之不易的防疫成果，请您如实填写问卷调查相关问题，积极配合防疫工作。同时，我们将严格保护您的个人信息安全。
        </div>
        <div class="word1">感谢您的配合！</div>
        <div class="peiheDibu">
          <button @click="peiheShow = false">好的，知道了</button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="successShow" class="success"
      ><div class="inSuccess">
        <div class="chaIcon" @click="successShow = false">
          <img src="../assets/images/yimiaoCha.png" alt="" />
        </div>
        <div class="successImg">
          <img src="../assets/images/yimiaoSuccess.png" alt="" />
        </div>
        <div class="successDibu">
          <button @click="successShow = false">确定</button>
        </div>
      </div></van-popup
    >
    <van-popup v-model="tishiShow" class="tishi">
      <div class="inTishi">
        <div class="chaIcon" @click="tishiShow = false">
          <img src="../assets/images/yimiaoCha.png" alt="" />
        </div>
        <div class="word word1">您已提交过问卷，感谢您的</div>
        <div class="word">配合！</div>
        <div class="tishiDibu">
          <button @click="tishiShow = false">确定</button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
        title="证件类型"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { doRem } from "../utils/setrem";
import { Popup } from "vant";
import qs from "qs";
import { Dialog } from "vant";
Vue.use(Popup);
export default {
  mounted() {

    this.peiheShow = true;
  },
  data() {
    return {
      isInoculation: null,
      typeShow: false,
      name: "",
      cardNum: "",
      phone: "",
      certType: null,
      type: "",
      peiheShow: false,
      successShow: false,
      tishiShow: false,
      yesUnselShow: true,
      yesSelShow: false,
      noUnselShow: true,
      noSelShow: false,
      radio: "1",
      activeIcon: require("../assets/images/yimiaoSel.png"),
      inactiveIcon: require("../assets/images/yimiaoUnsel.png"),
      showPicker: false,
      columns: [
        "身份证",
        "台湾居民来往大陆通行证",
        "港澳居民来往内地通行证(澳门)",
        "港澳居民来往内地通行证(香港)",
        "外国人永久居留身份证",
        "外国护照",
      ],
    };
  },
  methods: {
    onConfirm(value) {
      this.type = value;
      console.log(this.type);
      if (this.type == "身份证") {
        this.certType = 1;
      }
      if (this.type == "台湾居民来往大陆通行证") {
        this.certType = 2;
      }
      if (this.type == "港澳居民来往内地通行证(澳门)") {
        this.certType = 3;
      }
      if (this.type == "港澳居民来往内地通行证(香港)") {
        this.certType = 4;
      }
      if (this.type == "外国人永久居留身份证") {
        this.certType = 5;
      }
      if (this.type == "外国护照") {
        this.certType = 6;
      }
      console.log(this.certType);
      this.showPicker = false;
      this.typeShow = true;
    },
    showSel() {
      this.showPicker = true;
    },
    submit() {
      let regIDCard =
        /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      let regName = /^\D{2,16}$/;
      let regPhone = /^1[3-9]\d{9}$/;
      let regCard = /^[0-9a-zA-Z]{5,30}$/;
      if (!regName.test(this.name)) {
        this.$toast("请输入正确的姓名");
        return;
      }
      if (this.certType == null) {
        this.$toast("请选择证件类型");
        return;
      }
      if (!regCard.test(this.cardNum)) {
        this.$toast("请输入5-30位正确的证件号");
        return;
      }
      if (this.type == "身份证") {
        if (!regIDCard.test(this.cardNum)) {
          this.$toast("请填写正确的身份证号");
          return;
        }
      }
      if (!regPhone.test(this.phone)) {
        this.$toast("请填写正确的手机号");
        return;
      }
      if (this.radio == 1) {
        this.isInoculation = 1;
      }
      if (this.radio == 2) {
        this.isInoculation = 2;
      }
      let params = qs.stringify({
        isInoculation: this.isInoculation,
        name: this.name,
        certType: this.certType,
        certNo: this.cardNum,
        phone: this.phone,
      });
      this.$axios
        .post("/vaccinationquery/inputInfo/saveInfo", params)
        .then((res) => {
          console.log(res);
          if (res.data.result == -2) {
            this.radio = "1";
            this.tishiShow = true;
            this.successShow = true;
            this.name = "";
            this.typeShow = false;
            this.type = "";
            this.phone = "";
            this.cardNum = "";
            return;
          }
          if (res.data.result != 1) {
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {
              this.radio = "1";
              this.tishiShow = true;
              this.successShow = true;
              this.name = "";
              this.typeShow = false;
              this.type = "";
              this.phone = "";
              this.cardNum = "";
            });
            return;
          }
          if (res.data.result == 1) {
            console.log(res);
            this.radio = "1";
            this.successShow = true;
            this.name = "";
            this.typeShow = false;
            this.type = "";
            this.phone = "";
            this.cardNum = "";
          }
        })
        .catch((err) => {
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.yimiaoDiaocha {
  background-color: #eef4f6;
  background-image: url("../assets/images/yimiaoBg.png");
  background-size: 100% 13.25rem;
  background-repeat: no-repeat;
  min-height: 100vh;
  padding: 6.375rem 2rem 0 2rem;
}
.head {
  background-color: #fff;
  padding: 2.875rem 2.125rem 2.625rem 2.125rem;
  box-shadow: 0px 0px 4px rgba(205, 205, 205, 0.25);
  border-radius: 6px;
  .ques {
    color: #19212a;
    font-size: 2rem;
    line-height: 3rem;
  }
  .sel {
    margin-top: 3rem;
  }
}
.form {
  background-color: #fff;
  margin-top: 2rem;

  .everyForm {
    padding: 2.375rem 2.125rem 2.125rem 2.125rem;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e5e5e5;
    align-items: center;
    .left {
      color: #19212a;
      font-size: 2rem;
      white-space: nowrap;
    }
    .right {
      width: 20.625rem;
      input {
        border: none;
        text-align: right;
        color: #19212a;
        font-size: 1.75rem;
        width: 20.625rem;
      }
    }
    .rightSel {
      display: flex;
      align-items: center;
      // width: 20.625rem;
      img {
        width: 0.9375rem;
        height: 1.5rem;
      }
      .word {
        color: #878787;
        font-size: 1.75rem;
        margin-right: 0.625rem;
      }
      .word2 {
        margin-right: 0.625rem;
        color: #19212a;
        font-size: 1.75rem;
      }
    }
  }
  .last {
    border: none;
  }
}
.dibu {
  padding: 0 2rem;
  margin-top: 3.875rem;
  button {
    height: 5.5rem;
    width: 100%;
    border: none;
    background: linear-gradient(90deg, #19a0a0 0%, #0f7876 100%);
    border-radius: 22px;
    color: #ffffff;
    font-size: 2rem;
    font-weight: 700;
    line-height: 5.5rem;
  }
}
.peihe {
  width: 90%;
  background: #ffffff;
  border-radius: 6px;
  .inpeihe {
    padding: 2.125rem 1.75rem 3.625rem 3.25rem;
    .chaIcon {
      text-align: right;
      img {
        width: 1.625rem;
        height: 1.625rem;
      }
    }
    .title {
      color: #555555;
      font-size: 1.875rem;
      font-weight: bold;
      margin-top: 1.25rem;
    }
    .word1 {
      text-indent: 3.25rem;
      color: #555555;
      font-size: 1.625rem;
      margin-top: 1.25rem;
      line-height: 2.75rem;
      letter-spacing: 0.125rem;
    }
    .peiheDibu {
      margin-top: 3rem;
      display: flex;
      justify-content: center;
      button {
        padding: 0 4.5rem;
        height: 5rem;
        width: 25rem;
        background: linear-gradient(90deg, #19a0a0 0%, #0f7876 100%);
        border-radius: 22px;
        border: none;
        color: #ffffff;
        font-size: 2rem;
        line-height: 5rem;
        font-weight: bold;
      }
    }
  }
}
.success {
  width: 90%;
  background: #ffffff;
  border-radius: 6px;
  .inSuccess {
    padding: 2.25rem 1.75rem 4rem 0;
    .chaIcon {
      text-align: right;
      img {
        width: 1.625rem;
        height: 1.625rem;
      }
    }
    .successImg {
      display: flex;
      justify-content: center;
      margin-top: 4.5rem;
      img {
        width: 26.75rem;
        height: 17.75rem;
      }
    }
    .successDibu {
      margin-top: 3.875rem;
      padding: 0 9rem;
      button {
        width: 100%;
        height: 5rem;
        border: none;
        background: linear-gradient(90deg, #19a0a0 0%, #0f7876 100%);
        border-radius: 22px;
        color: #ffffff;
        font-size: 2rem;
      }
    }
  }
}
.tishi {
  width: 90%;
  background: #ffffff;
  border-radius: 6px;
  .inTishi {
    padding: 2.25rem 1.75rem 4rem 0;
    .chaIcon {
      text-align: right;
      img {
        width: 1.625rem;
        height: 1.625rem;
      }
    }
    .word {
      color: #19212a;
      font-size: 2.125rem;
      line-height: 3.125rem;
      text-align: center;
    }
    .word1 {
      margin-top: 4.25rem;
    }
    .tishiDibu {
      margin-top: 3.875rem;
      padding: 0 9rem;
      button {
        width: 100%;
        height: 5rem;
        border: none;
        background: linear-gradient(90deg, #19a0a0 0%, #0f7876 100%);
        border-radius: 22px;
        color: #ffffff;
        font-size: 2rem;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.sel ::v-deep .van-radio--horizontal {
  margin-right: 8.625rem;

  .van-radio__icon {
    height: 2.25rem;
    img {
      width: 2.25rem;
      height: 2.25rem;
      display: block;
    }
  }
  .van-radio__label {
    color: #000000;
    font-size: 2rem;
    margin-left: 1.875rem;
  }
}
</style>